export enum SubscriptionType {
  FRIENDS = 'FRIENDS',
  STUDENTS = 'STUDENTS',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}
